import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { DatePickerModule } from 'primeng/datepicker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';

import { TokenInterceptor } from './shared/token.interceptor';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { MarkdownModule } from 'ngx-markdown';
import { ToastNoAnimation, ToastNoAnimationModule, ToastrModule } from 'ngx-toastr';

import { registerLocaleData } from '@angular/common';
import LocaleSrCyrl from '@angular/common/locales/sr';
import LocaleSr from '@angular/common/locales/sr-Latn';
import { RequestComponent } from './request/request.component';

// Angular-ovi CLDR podaci za sr-Latn nemaju pravila množine (plural fn uvek vraća "other"),
// pa se preuzimaju iz sr podataka da bi i18nPlural radio ispravno (one/few/other)
LocaleSr[LocaleSr.length - 1] = LocaleSrCyrl[LocaleSrCyrl.length - 1];
registerLocaleData(LocaleSr, 'sr-Latn');

const BanimPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{orange.50}',
      100: '{orange.100}',
      200: '{orange.200}',
      300: '{orange.300}',
      400: '{orange.400}',
      500: '{orange.500}',
      600: '{orange.600}',
      700: '{orange.700}',
      800: '{orange.800}',
      900: '{orange.900}',
      950: '{orange.950}'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}'
        },
        formField: {
          background: '#ffffff',
          disabledBackground: '{surface.200}',
          filledBackground: '{surface.50}',
          filledFocusBackground: '#ffffff',
          borderColor: '{surface.300}',
          hoverBorderColor: '{surface.400}',
          focusBorderColor: '{primary.color}',
          invalidBorderColor: '{red.400}',
          color: '{surface.700}',
          disabledColor: '{surface.500}',
          placeholderColor: '{surface.500}',
          floatLabelColor: '{surface.500}',
          floatLabelFocusColor: '{primary.600}',
          floatLabelActiveColor: '{surface.500}',
          floatLabelInvalidColor: '{red.400}',
          iconColor: '{surface.400}',
          shadow: 'none'
        }
      }
    }
  },
  components: {
    datepicker: {
      colorScheme: {
        light: {
          background: '#ffffff',
          panelBackground: '#ffffff',
          headerBackground: '#ffffff',
          borderColor: '{surface.300}'
        }
      }
    }
  }
});

@NgModule({
  declarations: [
    AppComponent,
    RequestComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule.forRoot(),
    ToastNoAnimationModule,
    ToastrModule.forRoot({
      toastComponent: ToastNoAnimation,
      closeButton: true,
      tapToDismiss: false,
      timeOut: 3000,
      // disableTimeOut: true
    }),
    LoadingBarHttpClientModule,
    MarkdownModule.forRoot(),
    DatePickerModule
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: BanimPreset,
        options: {
          darkModeSelector: false
        }
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
